import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'sc-field-button-toggle',
  templateUrl: './field-button-toggle.component.html',
  styleUrls: ['./field-button-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldButtonToggleComponent extends FieldType implements OnInit {
  ngOnInit(): void {}
}
